export default function loadImage(image: any) {
	return new Promise((resolve, reject) => {
		const loadImg = new Image()
		loadImg.src = image.url
		// wait 2 seconds to simulate loading time
		loadImg.onload = () =>
			setTimeout(() => {
				resolve(image.url)
			}, 500)

		loadImg.onerror = (err) => reject(err)
	})
}
